import { generatePath } from "react-router";
import { ROUTES } from "../routes";
import { OBJECT_NAMES_TO_OBJECT_URL_NAMES, ObjectName } from "./enums";

export function getLinkToComponentEditModal(
  objectName: ObjectName,
  componentId: number,
  projectId: string,
  siteId: number
) {
  if (objectName === ObjectName.Generator) {
    return generatePath(ROUTES.site.generator, {
      projectId,
      siteId: siteId.toString(),
      componentId: componentId.toString()
    });
  }

  const path = generatePath(ROUTES.siteComponentPage, {
    projectId,
    siteId: siteId.toString(),
    objectUrlName: OBJECT_NAMES_TO_OBJECT_URL_NAMES[objectName],
    componentId: componentId.toString()
  });

  return path;
}
